import { apiClient } from './client';
import type { ApiResponse } from '@/types/api';

type ImageUploadResponse = {
  imageUrl: string;
};

/**
 * Uploads a single file to WordPress via the backend proxy.
 * Returns the public URL of the uploaded image.
 */
export async function wpUploadImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);

  const res = await apiClient.post<ApiResponse<ImageUploadResponse>>(
    '/api/media/upload',
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    },
  );

  return res.data.data.imageUrl;
}

/**
 * Uploads multiple files to WordPress via the backend proxy in parallel.
 * Returns an array of public URLs.
 */
export async function wpUploadImages(files: File[]): Promise<string[]> {
  const results = await Promise.all(files.map(wpUploadImage));
  return results;
}
